module.exports = __webpack_public_path__ + "static/media/incorrecto_castellano.25205d49.png";